import { render, staticRenderFns } from "./BehaviourEffect.vue?vue&type=template&id=15113ee6&scoped=true&"
import script from "./BehaviourEffect.vue?vue&type=script&lang=js&"
export * from "./BehaviourEffect.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourEffect.vue?vue&type=style&index=0&id=15113ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15113ee6",
  null
  
)

export default component.exports